export default {
  rfi: {
    pages: {
      search: {
        header: {
          title: 'Solicitudes de Información',
        },
        body: {
          filters: {
            placeholders: {
              search: 'Buscar por ID Solicitud, Descripción de Solicitud, Descripción del Item Solicitado',
            },
          },
          actions: {
            search: 'Buscar',
            see_rfi: 'Ver Solicitud',
          },
          table: {
            statuses: {
              published: 'Publicada',
              closed: 'Cerrada',
            },
            responses: {
              without_responding: 'Sin Responder',
              answered: 'Respondida',
            },
            columns: {
              id: 'ID Solicitud',
              name: 'Nombre',
              created_at: 'Fecha de creación',
              close_date: 'Fecha de cierre',
              status: 'Estado de la solicitud',
              user: 'Usuario',
              buyer: 'Comprador',
              keyword: 'Palabra buscada',
              item: 'Ítem',
              sku: 'Sku',
              price: 'Precio',
              code: 'Código',
              category: 'Categoría',
              search_type: 'Tipo de búsqueda',
            },
          },
        },
      },
      request: {
        header: {
          title: 'Request for Information',
        },
        body: {
          filters: {
            placeholders: {
              search: 'Search by Request ID, Request Description, Description of the Requested Item',
            },
          },
          actions: {
            search: 'Search',
            save: 'Save',
            reply: 'Reply Request',
            voucher: 'Voucher',
          },
          entity: {
            statuses: {
              published: 'Published',
              closed: 'Closed',
            },
            responses: {
              without_responding: 'Unanswered',
              answered: 'Answered',
            },
            buyer: 'Buyer',
            description_search: 'Search Description',
            number: 'Number',
            status: 'Request status',
            request: 'Request',
            response: 'Status Response',
            name: 'Name',
            notes: 'Notes',
            response_deadline: 'Response Deadline',
            attachment: 'attachment',
            see_attachment: 'See attached',
            reply_request: 'Reply Request',
            yes: 'Yes',
            no: 'Not',
            attachments: {
              title: 'Attachments',
              placeholder: 'Add attachment for this item (optional)',
              change_attachment: 'Change attachments',
              response: 'Answer',
            },
            items_match: {
              title: 'Items in your catalog matching the Search Description',
              selected_item: 'Selected item',
              description: 'Description',
              price: 'Price',
              currency: 'Currency',
              offer: {
                title: 'Enter price offer for this item (optional)',
              },
            },
            stock: {
              title: 'Stock confirmation',
              requested_amount: 'Requested amount',
              requested_uom: 'Unit of Measure Requested',
              do_you_have: 'Do you have the quantity of units of measure requested?',
              alternative_available: 'Enter Available Stock Alternative',
              quantity_available: 'Quantity Available',
              uom_available: 'Unit of Measure Available',
            },
            delivery: {
              title: 'Delivery availability',
              delivery_date: 'Delivery date',
              place_of_delivery: 'Place of delivery',
              do_you_have: 'Do you have feasibility of delivery for the indicated date and place?',
              alternative: 'Enter Delivery Availability Alternative',
            },
            technical: {
              title: 'Technical Clarifications',
              specifications: 'Technical specifications',
              response: 'Answer',
              guarantee: 'Guarantee and Quality',
              use: 'About usage',
              origin: 'Origin and Manufacture',
              additional: 'Additional Information',
            },
            observations: 'Observations',
            created_at: 'Creation date',
            item: 'Item',
            sku: 'Sku',
            price: 'Price',
            code: 'Code',
            category: 'Category',
            search_type: 'Search type',
          },
        },
      },
      resumen: {
        title: 'Response summary',
        messages: {
          note: 'We will save your request before it is sent',
          rule: 'Only validated items will be considered',
        },
        actions: {
          reply: 'Send Reply',
        },
        entity: {
          validated_items: 'Validated items',
          not_validated_items: 'Unvalidated items',
          observations: 'General remarks',
        },
      },
      voucher: {
        title: 'Voucher',
        messages: {
          note: 'Shipment information',
        },
        actions: {
          reply: 'Send Reply',
        },
        entity: {
          shipping_date: 'Shipping date',
          sent_by: 'Sent by',
          items_answered: 'Items answered',
          observations: 'General remarks',
        },
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/i18n/en-us/rfi.js